import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toLower } from 'lodash';
import { Source, Layer } from 'react-map-gl';
import { point, featureCollection } from '@turf/helpers';
import Shapes from '../../../utils/ShapeOfTypes';
import StopPopup from './StopPopup';
import { clusterLayer, unclusteredPointLayer } from './MapClusterConfig';
import mapboxConfig from './MapConfig';

const {
  clusterMaxZoom, clusterRadius,
} = mapboxConfig;

const getIconType = (name) => {
  let type = 'bus';
  if (toLower(name).indexOf('train station') !== -1) {
    type = 'train';
  } else if (toLower(name).indexOf('ferry terminal') !== -1) {
    type = 'ferry';
  }
  return type;
};

const convertStops = (stops) => {
  // Convert "stops" to GeoJson format
  const points = stops.map((stop) => {
    // eslint-disable-next-line camelcase, object-curly-newline
    const { stop_id, stop_lat, stop_lon, stop_name } = stop;
    const stopIcon = getIconType(stop_name);
    // eslint-disable-next-line camelcase
    return point([stop_lon, stop_lat], { id: stop_id, icon: stopIcon });
  });

  return featureCollection(points);
};

const StopsLayer = ({
  enableAccessibilityOutlines,
  onPopupClose,
  selectedStop,
  selectStop,
  stops,
}) => {
  const [stopsFeatureCollection, setStopsFeatureCollection] = useState(() => convertStops(stops));

  useEffect(() => {
    setStopsFeatureCollection(convertStops(stops));
  }, [stops]);

  const _onSelect = () => {
    selectStop(selectedStop);
  };

  return (
    <>
      <Source
        id="stop_cluster"
        type="geojson"
        data={stopsFeatureCollection}
        cluster
        clusterMaxZoom={clusterMaxZoom}
        clusterRadius={clusterRadius}
      >
        <Layer {...clusterLayer} />
        <Layer {...unclusteredPointLayer} />
      </Source>
      <StopPopup
        enableAccessibilityOutlines={enableAccessibilityOutlines}
        offset={selectedStop ? 50 : 0}
        onPopupClose={onPopupClose}
        onSelect={_onSelect}
        selectedStop={selectedStop}
      />
    </>
  );
};

StopsLayer.propTypes = {
  enableAccessibilityOutlines: PropTypes.func.isRequired,
  onPopupClose: PropTypes.func.isRequired,
  selectedStop: PropTypes.object,
  selectStop: PropTypes.func.isRequired,
  stops: Shapes.Stops,
};
StopsLayer.defaultProps = {
  selectedStop: null,
  stops: [],
};

export default StopsLayer;
